// extracted by mini-css-extract-plugin
module.exports = {"avatarCell":"avatarCell--dZl8t"};